import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_FORGOT_PASSWORD').plugin(axiosPlugin);

let forgotPasswordAction = redux.fetchActionCreate();

export const sendForgotPassword = (data = {}) => forgotPasswordAction(`/users/accounts/forgot-password`, data);
export const resetPassword = (data = {}) => forgotPasswordAction(`/users/accounts/reset-password`, data);

export const userForgotPassword = redux.reducer();